import { RemoveCircle, Tag } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();

  return (
    <NodeCard color="#dc3545" icon={<RemoveCircle />} title="Remover Tag" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={`${classes.slot} ${classes.slotRow}`}>
        <Tag />
        <span className={classes.ellipsis}>{data?.tag?.name || "Tag não selecionada"}</span>
      </div>
      {data?.tag?.name && <div className={classes.hint}>Remove a tag do contato</div>}
      {/* saída sem id, como sempre foi: as conexões salvas dependem disso */}
      <NodeHandle type="source" isConnectable={isConnectable} />
    </NodeCard>
  );
});
